<template>
  <div class="quetions-common">
    <div class="quItem" v-for="item in qus" :key="item.QuestionsID">
      <h3 class="queTit">
        {{ item.QuestionsQusTitle }}<span style="color: red" v-if="item.Questions_IsRequired">*</span>
        <span class="queTit-en">{{ item.QuestionsQusETitle }}</span>
        
      </h3>
      <div class="queSelItem">
        <!-- 多选 -->
        <van-checkbox-group
          v-if="item.Question_QusType === 'M'"
          v-model="item.checked"
        >
          <div class="opItem">
            <template
              v-for="itemo in item.AnswersCollect"
              :key="itemo.AnswersID"
            >
              <!-- 二级 -->
              <div
                class="hasSec"
                v-if="itemo.ChildAnswers && itemo.ChildAnswers.length > 0"
              >
                <van-checkbox-group
                  v-model="itemo.firstChecked"
                  @change="firstCheckChange(item, itemo)"
                >
                  <van-checkbox
                    :key="itemo.AnswersID"
                    :name="itemo.AnswersID"
                    :checked-color="mainColor"
                    icon-size="18px"
                    shape="square"
                  >
                    {{ itemo.AnswersTitle }}
                    <span class="ans-en">{{ itemo.AnswersETitle }}</span>
                  </van-checkbox>
                </van-checkbox-group>
                <!-- 二级显示 -->
                <div v-show="itemo.firstChecked.length > 0">
                  <div
                    v-for="items in itemo.ChildAnswers"
                    :key="items.AnswersID"
                    class="secBox"
                  >
                    <van-checkbox
                      :checked-color="mainColor"
                      icon-size="18px"
                      shape="square"
                      :name="items.AnswersID"
                      :class="items.AnswersIsInput ? 'otherTxt' : ''"
                      @click="changeQueAns(item, items)"
                    >
                      {{ items.AnswersTitle }}
                      <span class="ans-en">{{ items.AnswersETitle }}</span>
                    </van-checkbox>
                    <!-- 其他 -->
                    <van-field
                      v-if="items.AnswersIsInput"
                      v-model="items.otherCon"
                      @click.stop
                      class="otherConFiled"
                      :disabled="item.checked.indexOf(items.AnswersID) === -1"
                      :placeholder="items.AnswersInputText || '请填写'"
                    />
                  </div>
                </div>
              </div>
              <!-- 二级end -->
              <!-- 一级 -->
              <div v-else>
                <van-checkbox
                  :checked-color="mainColor"
                  icon-size="18px"
                  shape="square"
                  :name="itemo.AnswersID"
                  :class="itemo.AnswersIsInput ? 'otherTxt' : ''"
                  @click="changeQueAns(item, itemo)"
                >
                  {{ itemo.AnswersTitle }}
                  <span class="ans-en">{{ itemo.AnswersETitle }}</span>
                </van-checkbox>
                <!-- 其他 -->
                <van-field
                  v-if="itemo.AnswersIsInput"
                  v-model="itemo.otherCon"
                  @click.stop
                  class="otherConFiled"
                  :disabled="item.checked.indexOf(itemo.AnswersID) === -1"
                  :placeholder="itemo.AnswersInputText || '请填写'"
                />
              </div>
              <!-- 一级end -->
            </template>
          </div>
        </van-checkbox-group>
        <!-- 单选 -->
        <van-radio-group
          v-if="item.Question_QusType === 'S'"
          v-model="item.checked"
        >
          <template v-for="itemo in item.AnswersCollect" :key="itemo.AnswersID">
            <div
              class="hasSec"
              v-if="itemo.ChildAnswers && itemo.ChildAnswers.length > 0"
            >
              <van-radio
                :checked-color="mainColor"
                icon-size="18px"
                :name="itemo.AnswersID"
                :class="itemo.AnswersIsInput ? 'otherTxt' : ''"
                @click="firstCheckChange(item, itemo)"
              >
                {{ itemo.AnswersTitle }}
                <span class="ans-en">{{ itemo.AnswersETitle }}</span>
              </van-radio>
              <!-- 单选二级 -->
              <div
                v-show="item.checked === itemo.AnswersID"
                style="padding-left: 15px"
              >
                <van-radio-group v-model="itemo.firstChecked">
                  <template
                    v-for="items in itemo.ChildAnswers"
                    :key="items.AnswersID"
                  >
                    <van-radio
                      :checked-color="mainColor"
                      icon-size="18px"
                      :name="items.AnswersID"
                      :class="items.AnswersIsInput ? 'otherTxt' : ''"
                      @click="changeQueAns(item, items)"
                    >
                      {{ items.AnswersTitle }}
                      <span class="ans-en">{{ items.AnswersETitle }}</span>
                    </van-radio>
                    <!-- 其他 -->
                    <van-field
                      v-if="items.AnswersIsInput"
                      v-model="items.otherCon"
                      @click.stop
                      class="otherConFiled"
                      :placeholder="items.AnswersInputText || '请填写'"
                      :disabled="itemo.firstChecked !== items.AnswersID"
                    />
                  </template>
                </van-radio-group>
              </div>
            </div>
            <div v-else>
              <van-radio
                :checked-color="mainColor"
                icon-size="18px"
                :name="itemo.AnswersID"
                :class="itemo.AnswersIsInput ? 'otherTxt' : ''"
                @click="changeQueAns(item, itemo)"
              >
                {{ itemo.AnswersTitle }}
                <span class="ans-en">{{ itemo.AnswersETitle }}</span>
              </van-radio>
              <!-- 其他 -->
              <van-field
                v-if="itemo.AnswersIsInput"
                v-model="itemo.otherCon"
                @click.stop
                class="otherConFiled"
                :placeholder="itemo.AnswersInputText || '请填写'"
                :disabled="item.checked !== itemo.AnswersID"
              />
            </div>
          </template>
        </van-radio-group>
        <!-- 填空 -->
        <van-radio-group
          v-if="item.Question_QusType === 'F'"
          v-model="item.checked"
        >
          <template v-for="itemo in item.AnswersCollect" :key="itemo.AnswersID">
            <div>
              <van-radio
                style="display: none"
                :checked-color="mainColor"
                icon-size="18px"
                :name="itemo.AnswersID"
                :class="itemo.AnswersIsInput ? 'otherTxt' : ''"
                @click="changeQueAns(item, itemo)"
              >
                {{ itemo.AnswersTitle }}
              </van-radio>
              <!-- 其他 -->
              <van-field
                v-if="itemo.AnswersIsInput"
                v-model="itemo.otherCon"
                @click.stop
                class="otherConFiled"
                :placeholder="itemo.AnswersInputText || '请填写'"
                :disabled="item.checked !== itemo.AnswersID"
              />
            </div>
          </template>
        </van-radio-group>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted, computed, defineProps } from 'vue'
import { showFailToast } from 'vant'
import { useStore } from 'vuex'

const store = useStore()
const props = defineProps({
  modelValue: '',
  quesConfig: {
    type: Array,
    default: () => []
  }
})

const ExhCode = computed(() => store.state.ExhCode)
const mainColor = computed(() => store.state.mainColor)
const customType = computed(() => {
  let tmpStr = '普通观众'
  return tmpStr
})
const firstCheckChange = (qObj, fObj) => {
  if (qObj.Question_QusType === 'M') {
    if (fObj.firstChecked.length <= 0) {
      fObj.ChildAnswers.forEach((item) => {
        item.otherCon = ''
        const index = qObj.checked.indexOf(item.AnswersID)
        if (index > -1) {
          qObj.checked.splice(index, 1)
        }
      })
    }
  } else {
    // 一级单选切换
    qObj.AnswersCollect.forEach((item) => {
      if (item.ChildAnswers && item.ChildAnswers.length > 0) {
        item.firstChecked = ''
        item.ChildAnswers.forEach((items) => {
          items.otherCon = ''
        })
      }
    })
  }
}
const qus = ref([])
const qusSec = ref([]) // 问题215：是否涉及氢能业务
const qusThird = ref([]) // 问题196：产业链环节
const getAns = async () => {
  // const res = await api.getAnswersApi({ ExhCode: ExhCode.value })
  // let jmRes = JSON.parse(decryptionECB(res.data))
  // 问题215和196默认不显示，根据条件动态添加
  if (props.quesConfig.length >= 3) {
    // 找到并移除问题215（索引1）
    const idx215 = props.quesConfig.findIndex(q => q.QuestionsID === 215)
    if (idx215 > -1) {
      qusSec.value = props.quesConfig.splice(idx215, 1)
    }
    // 找到并移除问题196
    const idx196 = props.quesConfig.findIndex(q => q.QuestionsID === 196)
    if (idx196 > -1) {
      qusThird.value = props.quesConfig.splice(idx196, 1)
    }
  }
  qus.value = props.quesConfig

  // let jmRes = {
  //   AnswersQuestions: quesConfig
  // }
  // jmRes.AnswersQuestions = jmRes.AnswersQuestions.sort((a, b) => {
  //   return a.Questions_Sort - b.Questions_Sort
  // })
  // jmRes.AnswersQuestions.forEach((item) => {
  //   if (item.AnswersCollect && item.AnswersCollect.length > 0) {
  //     // 二级选项排序
  //     item.AnswersCollect.forEach((item2) => {
  //       if (item2.ChildAnswers && item2.ChildAnswers.length > 0) {
  //         item2.ChildAnswers = item2.ChildAnswers.sort((e, f) => {
  //           return e.AnswersSort - f.AnswersSort
  //         })
  //       }
  //     })
  //     item.AnswersCollect = item.AnswersCollect.sort((c, d) => {
  //       return c.AnswersSort - d.AnswersSort
  //     })
  //   }
  // })
  // qus.value = jmRes.AnswersQuestions.map((item) => {
  //   if (item.Question_QusType === 'S') {
  //     // 单选
  //     item.checked = ''
  //     // 单选二级
  //     item.AnswersCollect.forEach((item2) => {
  //       if (item2.ChildAnswers && item2.ChildAnswers.length > 0) {
  //         item2.firstChecked = ''
  //       }
  //     })
  //   }
  //   if (item.Question_QusType === 'M') {
  //     // 多选
  //     item.checked = []
  //     // 多选二级
  //     item.AnswersCollect.forEach((item2) => {
  //       if (item2.ChildAnswers && item2.ChildAnswers.length > 0) {
  //         item2.firstChecked = []
  //       }
  //     })
  //   }
  //   // 填空
  //   if (item.Question_QusType === 'F') {
  //     // 单选
  //     item.checked = item.AnswersCollect[0].AnswersID
  //   }
  //   if (item.AnswersCollect.length > 0) {
  //     item.AnswersCollect.map((itemo) => {
  //       itemo.otherCon = ''
  //     })
  //     item.AnswersCollect.forEach((item2) => {
  //       if (item2.ChildAnswers && item2.ChildAnswers.length > 0) {
  //         // 二级其他
  //         item2.ChildAnswers.forEach((items) => {
  //           items.otherCon = ''
  //         })
  //       }
  //     })
  //   }
  //   return item
  // })
  //.filter((item2) => item2.QuestionsQusETitle.indexOf(customType.value) > -1)
}
onMounted(() => {
  getAns()
})
const emit = defineEmits('update:modelValue')
const ansArr = ref([])
const nextHandler = () => {
  ansArr.value = []
  for (let i = 0; i < qus.value.length; i++) {
    const item = qus.value[i]
    if (item.Questions_IsRequired) {
      // 如果必填
      if (item.Question_QusType === 'S') {
        // 单选
        if (item.checked === '' || item.checked === undefined || (Array.isArray(item.checked) && item.checked.length === 0)) {
          showFailToast(`请回答 "${item.QuestionsQusTitle}"`)
          return false
        } else {
          const chooseAns = item.AnswersCollect.find((itemo) => {
            return itemo.AnswersID === item.checked
          })
          if (!chooseAns) {
            showFailToast(`请回答 "${item.QuestionsQusTitle}"`)
            return false
          }
          if (chooseAns.ChildAnswers && chooseAns.ChildAnswers.length > 0) {
            // 如果有二级
            if (chooseAns.firstChecked === '') {
              showFailToast(`请回答 "${item.QuestionsQusTitle}"`)
              return false
            } else {
              const schooseAns = chooseAns.ChildAnswers.find((items) => {
                return items.AnswersID === chooseAns.firstChecked
              })
              if (schooseAns && schooseAns.AnswersIsInput) {
                if (schooseAns.otherCon === '') {
                  showFailToast(`请填写问题 "${item.QuestionsQusTitle}"`)
                  return false
                }
              }
              if (schooseAns) {
                ansArr.value.push(
                  `${item.QuestionsID}:${schooseAns.AnswersID}:${schooseAns.otherCon}`
                )
              }
            }
          } else {
            if (chooseAns.AnswersIsInput) {
              if (chooseAns.otherCon === '') {
                showFailToast(`请填写问题 "${item.QuestionsQusTitle}"`)
                return false
              }
            }
            ansArr.value.push(
              `${item.QuestionsID}:${chooseAns.AnswersID}:${chooseAns.otherCon}`
            )
          }
        }
      }
      if (item.Question_QusType === 'M') {
        // 多选
        if (item.checked.length <= 0) {
          showFailToast(`请回答 "${item.QuestionsQusTitle}"`)
          return false
        } else {
          let chooseAnsArr = []
          item.AnswersCollect.forEach((itemo) => {
            if (item.checked.indexOf(itemo.AnswersID) !== -1) {
              chooseAnsArr.push(itemo)
            }
            // 循环二级
            if (itemo.ChildAnswers) {
              itemo.ChildAnswers.forEach((items) => {
                if (item.checked.indexOf(items.AnswersID) > -1) {
                  chooseAnsArr.push(items)
                }
              })
            }
          })
          for (let j = 0; j < chooseAnsArr.length; j++) {
            if (chooseAnsArr[j].AnswersIsInput) {
              if (!chooseAnsArr[j].otherCon) {
                showFailToast(`请填写问题 "${item.QuestionsQusTitle}"`)
                return false
              }
            }
            ansArr.value.push(
              `${item.QuestionsID}:${chooseAnsArr[j].AnswersID}:${chooseAnsArr[j].otherCon}`
            )
          }
        }
      }
      if (item.Question_QusType === 'F') {
        if (!item.AnswersCollect[0].otherCon) {
          showFailToast(`请回答 "${item.QuestionsQusTitle}"`)
          return false
        }
        ansArr.value.push(
          `${item.QuestionsID}:${item.checked}:${item.AnswersCollect[0].otherCon}`
        )
      }
    } else {
      // 如果非必填
      console.log(2222)
    }
  }
  emit('update:modelValue', ansArr.value.join(';'))
  return true
}
const changeQueAns = (obj, ansObj) => {
  // 处理隐藏题目显示
  // 问题195：选中2368（企业）时显示问题215
  if (obj.QuestionsID === 195) {
    if (obj.checked.indexOf(2368) > -1) {
      // 选中"企业"，添加问题215
      const has215 = qus.value.find(q => q.QuestionsID === 215)
      if (!has215 && qusSec.value.length > 0) {
        qus.value.splice(1, 0, qusSec.value[0])
      }
    } else {
      // 未选中"企业"，移除问题215和196
      const idx215 = qus.value.findIndex(q => q.QuestionsID === 215)
      if (idx215 > -1) {
        qus.value.splice(idx215, 1)
      }
      const idx196 = qus.value.findIndex(q => q.QuestionsID === 196)
      if (idx196 > -1) {
        qus.value.splice(idx196, 1)
      }
    }
  }
  // 问题215：选中2651（是）时显示问题196
  if (obj.QuestionsID === 215) {
    if (obj.checked === 2651) {
      // 选中"是"，添加问题196
      const has196 = qus.value.find(q => q.QuestionsID === 196)
      if (!has196 && qusThird.value.length > 0) {
        const idx215 = qus.value.findIndex(q => q.QuestionsID === 215)
        qus.value.splice(idx215 + 1, 0, qusThird.value[0])
      }
    } else {
      // 未选中"是"，移除问题196
      const idx196 = qus.value.findIndex(q => q.QuestionsID === 196)
      if (idx196 > -1) {
        qus.value.splice(idx196, 1)
      }
    }
  }
  if (obj.Question_QusType === 'S') {
    // 单选
    obj.AnswersCollect.forEach((item) => {
      if (item.AnswersIsInput) {
        item.otherCon = ''
      }
    })
  }
  if (
    obj.Question_QusType === 'M' &&
    obj.checked.indexOf(ansObj.AnswersID) === -1
  ) {
    // 多选
    ansObj.otherCon = ''
  }
}
defineExpose({ nextHandler })
</script>
<style lang="less">
.quItem{
  margin-left: 16px;
}
.secBox {
  padding: 6px 0 6px 27px;
}
.quetions-common {
  background: #fff;
  border-radius: 6px;
  .van-radio-group > div,
  .opItem > div {
    padding: 8px 0;
  }
  .van-checkbox__label {
    text-align: left;
  }
}
.quebtns {
  padding: 16px;
  display: flex;
  justify-content: space-between;
  .van-button {
    width: 45%;
  }
}
.queTit {
  text-align: left;
  padding: 0 0 0 0;
  font-size: 15px;
  font-weight: normal;
}
.queTit-en {
  display: block;
  font-size: 13px;
  color: #7a7979;
  font-weight: normal;
}
.ans-en {
  display: block;
  font-size: 12px;
  color: #7a7979;
}
.queSelItem {
  padding: 10px 0;
}
.quetions {
  // padding: 0 20px;
}
// .otherConFiled {
//   border: 1px solid #333;
//   border-radius: 4px;
//   padding: 0 8px;
// }
</style>
